module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-4.9d33537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-4.jpg
// module id = Z1WN
// module chunks = 0